import { keyBy } from 'lodash';

/*
  This functionality is implemented as a quickfix for https://jira.willhillatlas.com/browse/SBKS-2383 issue.
  Even though a better place for it is `make-feature-renderer` package it was decided to place it here because
  it is a tactical solution that should be removed in the very near future.

  This code searches recursively for configuration nodes that match renderers that implement `renderToPortal` method
  and runs `renderToPortal` with the nodes' configurations. Works only one level
  deep (only for nodes that are 'leaves' in configuration tree and have no children) which actualy
  covers our cases - login, registration and deposit.
*/

const makeFeatureRendererInPortal = portalRenderersByType =>
  function renderToPortal(node) {
    if (!node) return null;

    const { type, data = {}, children = [] } = node;
    const renderer = portalRenderersByType[type];

    if (renderer) {
      return renderer.renderToPortal({ type, data });
    }

    return children
      .map(nodeChild => renderToPortal(nodeChild))
      .filter(element => !Array.isArray(element));
  };

const getPortalRenderers = renderers => renderers.filter(renderer => renderer.renderToPortal);

export default renderers => {
  const renderersByType = keyBy(getPortalRenderers(renderers), 'type');
  return makeFeatureRendererInPortal(renderersByType);
};
